var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "customers-list" } },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("资源列表")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("资源列表")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, id: "search", size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单编号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入订单编号", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.fetchData("search")
                      },
                    },
                    model: {
                      value: _vm.search.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "orderNo", $$v)
                      },
                      expression: "search.orderNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户信息" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入客户姓名或手机号",
                      clearable: "",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.fetchData("search")
                      },
                    },
                    model: {
                      value: _vm.search.keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "keywords", $$v)
                      },
                      expression: "search.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入商品名称", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.fetchData("search")
                      },
                    },
                    model: {
                      value: _vm.search.goodsName,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "goodsName", $$v)
                      },
                      expression: "search.goodsName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "渠道" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择渠道",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.search.userDitch,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "userDitch", $$v)
                        },
                        expression: "search.userDitch",
                      },
                    },
                    _vm._l(_vm.userDitchList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.name,
                          value: item.id,
                          clearable: "",
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "来源" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择来源平台",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.search.platformId,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "platformId", $$v)
                        },
                        expression: "search.platformId",
                      },
                    },
                    _vm._l(_vm.platformList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "部门" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.orgCodeList,
                      props: {
                        checkStrictly: true,
                        multiple: true,
                        emitPath: false,
                        label: "orgName",
                        value: "orgCode",
                        children: "children",
                      },
                      "collapse-tags": "",
                    },
                    model: {
                      value: _vm.search.orgCodeList,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "orgCodeList", $$v)
                      },
                      expression: "search.orgCodeList",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    on: { change: _vm.onChangeCreate },
                    model: {
                      value: _vm.createDate,
                      callback: function ($$v) {
                        _vm.createDate = $$v
                      },
                      expression: "createDate",
                    },
                  }),
                ],
                1
              ),
              _vm.assignStatusCurrent === _vm.assignStatus.success
                ? _c(
                    "el-form-item",
                    { attrs: { label: "分配时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        on: { change: _vm.onChangeDate },
                        model: {
                          value: _vm.date1,
                          callback: function ($$v) {
                            _vm.date1 = $$v
                          },
                          expression: "date1",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "分配客服" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择跟进客服",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.search.customerServiceUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "customerServiceUserId", $$v)
                        },
                        expression: "search.customerServiceUserId",
                      },
                    },
                    _vm._l(_vm.salesAuthorityList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.reallyName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择类型",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.search.payType,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "payType", $$v)
                        },
                        expression: "search.payType",
                      },
                    },
                    _vm._l(
                      _vm.dictionaries.customer_channel_pay_type,
                      function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "类目" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      clearable: "",
                      options: _vm.categoryOptions,
                      props: {
                        label: "categoryName",
                        value: "id",
                        checkStrictly: true,
                      },
                      filterable: "",
                    },
                    on: { change: _vm.handleChangeSearch },
                    model: {
                      value: _vm.search.categoryId,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "categoryId", $$v)
                      },
                      expression: "search.categoryId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分配人" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择分配人",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.search.assignUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "assignUserId", $$v)
                        },
                        expression: "search.assignUserId",
                      },
                    },
                    _vm._l(_vm.assignorList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.reallyName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "批次" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入批次", clearable: "" },
                    model: {
                      value: _vm.search.batchNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "batchNumber", $$v)
                      },
                      expression: "search.batchNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "转移时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.transferDate,
                      callback: function ($$v) {
                        _vm.transferDate = $$v
                      },
                      expression: "transferDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "微信号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户微信号", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.fetchData("search")
                      },
                    },
                    model: {
                      value: _vm.search.wechatNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "wechatNo", $$v)
                      },
                      expression: "search.wechatNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("search")
                        },
                      },
                    },
                    [_vm._v("查询 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("reset")
                        },
                      },
                    },
                    [_vm._v("重置 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("资源分配列表")]),
          _c("div", { staticClass: "btn-list" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.loading,
                      plain: "",
                      type:
                        _vm.assignStatusCurrent === _vm.assignStatus.all
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeAssignStatus(_vm.assignStatus.all)
                      },
                    },
                  },
                  [_vm._v("全部 ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.loading,
                      plain: "",
                      type:
                        _vm.assignStatusCurrent ===
                        _vm.assignStatus.distributable
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeAssignStatus(
                          _vm.assignStatus.distributable
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "可分配(" +
                        _vm._s(_vm.distributionCount.wechatUnassignedNum) +
                        ") "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.loading,
                      size: "mini",
                      plain: "",
                      type:
                        _vm.assignStatusCurrent === _vm.assignStatus.fail
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeAssignStatus(_vm.assignStatus.fail)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "分配失败(" +
                        _vm._s(_vm.distributionCount.wechatAssignedErrorNum) +
                        ") "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.loading,
                      size: "mini",
                      plain: "",
                      type:
                        _vm.assignStatusCurrent === _vm.assignStatus.success
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeAssignStatus(
                          _vm.assignStatus.success
                        )
                      },
                    },
                  },
                  [_vm._v("分配成功 ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _vm.parArray.indexOf("allocation") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "mini", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.onDetail("e", 2)
                          },
                        },
                      },
                      [_vm._v("批量分配 ")]
                    )
                  : _vm._e(),
                _vm.parArray.indexOf("customeruserinfodelete") != -1 &&
                _vm.assignStatusCurrent == 3
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "danger", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.batchDelete()
                          },
                        },
                      },
                      [_vm._v("批量删除 ")]
                    )
                  : _vm._e(),
                _vm.parArray.indexOf("ImportClient") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.importClient },
                      },
                      [_vm._v("导入客户 ")]
                    )
                  : _vm._e(),
                _vm.parArray.indexOf("customertracking") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "success" },
                        on: { click: _vm.resourceFeedback },
                      },
                      [_vm._v("资源反馈 ")]
                    )
                  : _vm._e(),
                _vm.assignStatusCurrent == 2 &&
                _vm.parArray.indexOf("allocation") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "warning" },
                        on: { click: _vm.automationAllocation },
                      },
                      [_vm._v("自动分配 ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("lb-table", {
            directives: [
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: '"always"',
              },
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              column: _vm.column,
              data: _vm.list,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50, 100, 200, 300, 400, 500],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
              "selection-change": _vm.handleSelectionChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.allocation,
            "append-to-body": true,
            title: "自动分配",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.allocation = $event
            },
            close: _vm.handleAllocationDialogClose,
          },
        },
        [
          [
            _c(
              "div",
              { staticClass: "allocationForm" },
              [
                _c(
                  "el-form",
                  {
                    ref: "allocationForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      inline: true,
                      model: _vm.allocationForm,
                      rules: _vm.allocationRuleForm,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "分配计算方式", prop: "calculateWay" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "mini",
                              placeholder: "请选择更新方式",
                              filterable: "",
                              clearable: "",
                            },
                            on: { change: _vm.handlerSelectedNum },
                            model: {
                              value: _vm.allocationForm.calculateWay,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.allocationForm,
                                  "calculateWay",
                                  $$v
                                )
                              },
                              expression: "allocationForm.calculateWay",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.auto_assign_type,
                            function (item) {
                              return _c("el-option", {
                                key: item.dictId,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "类目", prop: "clientCategory" } },
                      [
                        _c("el-cascader", {
                          ref: "cascade",
                          attrs: {
                            placeholder: "请选择二级类目",
                            size: "mini",
                            clearable: "",
                            options: _vm.categoryOptions,
                            props: {
                              label: "categoryName",
                              value: "id",
                              checkStrictly: true,
                            },
                            filterable: "",
                          },
                          on: { change: _vm.selectClientCategory },
                          model: {
                            value: _vm.allocationForm.clientCategory,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.allocationForm,
                                "clientCategory",
                                $$v
                              )
                            },
                            expression: "allocationForm.clientCategory",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.allocationForm.calculateWay == 4
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "已选数量" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "60%" },
                              attrs: {
                                size: "mini",
                                placeholder: "请输入已选数量",
                                clearable: "",
                              },
                              on: {
                                input: (v) =>
                                  (_vm.allocationForm.selectedNum = v.replace(
                                    /[^\d]/g,
                                    ""
                                  )),
                                change: _vm.handlerInputNumber,
                              },
                              model: {
                                value: _vm.allocationForm.selectedNum,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.allocationForm,
                                    "selectedNum",
                                    $$v
                                  )
                                },
                                expression: "allocationForm.selectedNum",
                              },
                            }),
                            _c("span", { staticClass: "peopleNum" }, [
                              _vm._v("人数:" + _vm._s(_vm.numberPeople)),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "allocation_box" }, [
              _c("div", { staticClass: "allocation_left" }, [
                _c("div", { staticClass: "allocation_left_title" }, [
                  _vm._v("选择部门"),
                ]),
                _c(
                  "div",
                  { staticClass: "treeAllocation" },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "输入关键字进行搜索",
                        "prefix-icon": "el-icon-search",
                      },
                      model: {
                        value: _vm.filterText,
                        callback: function ($$v) {
                          _vm.filterText = $$v
                        },
                        expression: "filterText",
                      },
                    }),
                    _c("el-tree", {
                      ref: "allocationTree",
                      staticClass: "el-menu-vertical-demo",
                      attrs: {
                        data: _vm.orgCodeList,
                        "node-key": "id",
                        "default-expand-all": true,
                        props: _vm.defaultPropsNew,
                        "highlight-current": true,
                        "filter-node-method": _vm.filterNode,
                      },
                      on: { "node-click": _vm.handleNodeClickTwo },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ node, data }) {
                            return _c(
                              "span",
                              { staticClass: "custom-tree-node" },
                              [
                                _c("span", [_vm._v(_vm._s(node.label))]),
                                _c(
                                  "span",
                                  [
                                    node.level != 1 &&
                                    data.selectedList.length != 0
                                      ? _c("el-badge", {
                                          attrs: {
                                            value: data.selectedList.length,
                                            type: "primary",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "allocation_right" }, [
                _c("div", { staticClass: "allocation_right_titleBox" }, [
                  _c("div", { staticClass: "allocation_right_title" }, [
                    _vm._v(
                      " 已选员工：" + _vm._s(_vm.selectedStaff.length) + "人 "
                    ),
                  ]),
                  _c("div", { staticClass: "allocation_right_title_right" }, [
                    _vm.numberEstimate && _vm.numberEstimate != 0
                      ? _c("span", [
                          _vm._v(
                            "预估已选人均分配数量：" +
                              _vm._s(
                                _vm.numberEstimate == "Infinity"
                                  ? "0"
                                  : _vm.numberEstimate
                              )
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            "预估已选人均分配数量：" +
                              _vm._s(
                                _vm.estimatesNum == "Infinity"
                                  ? "0"
                                  : _vm.estimatesNum
                              )
                          ),
                        ]),
                    _c(
                      "span",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "allocation_right_title_btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.handlerEstimate },
                          },
                          [_vm._v("预估")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "table2" },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.allocationLoading,
                            expression: "allocationLoading",
                          },
                        ],
                        ref: "allocation",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "header-cell-style": { background: "#f8f8f8" },
                          data: _vm.staffTableList.list,
                          "row-key": "id",
                        },
                        on: {
                          "select-all": _vm.handleAutomaticAllocationAll,
                          select: _vm.handleAutomaticAllocationSelect,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            "reserve-selection": true,
                            width: "50",
                            align: "center",
                          },
                          model: {
                            value: _vm.automaticAllocation,
                            callback: function ($$v) {
                              _vm.automaticAllocation = $$v
                            },
                            expression: "automaticAllocation",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "员工" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("p", [
                                    _vm._v(_vm._s(props.row.reallyName)),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c(
                          "el-table-column",
                          {
                            attrs: {
                              label: "已分配资源数",
                              prop: "allocationNum",
                            },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _c("span", [
                                _vm._v(
                                  " 预估分配" + _vm._s(_vm.valueName) + " "
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                        _c(
                          "el-table-column",
                          {
                            attrs: { label: "预估分配数量" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("el-input", {
                                      model: {
                                        value: props.row.assignNum,
                                        callback: function ($$v) {
                                          _vm.$set(props.row, "assignNum", $$v)
                                        },
                                        expression: "props.row.assignNum",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _c("span", [
                                _vm._v(
                                  " 设置分配" + _vm._s(_vm.valueName) + " "
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                        _c("el-table-column", {
                          attrs: { label: "上次分配时间", prop: "assignTime" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        props.row.assignTime
                                          ? props.row.assignTime
                                          : "-"
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.staffTableList.totalNum > 0
                  ? _c("div", { staticClass: "allocation_pagination" }, [
                      _c(
                        "div",
                        { staticClass: "block" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.stafpage,
                              "page-size": _vm.stafPageSize,
                              layout: "total,sizes,prev, pager, next",
                              "prev-text": "上一页",
                              "next-text": "下一页",
                              total: _vm.staffTableList.totalNum,
                            },
                            on: {
                              "size-change": _vm.handleSizeEmplayNew,
                              "current-change": _vm.handleCurrentEmplayNew,
                              "update:currentPage": function ($event) {
                                _vm.stafpage = $event
                              },
                              "update:current-page": function ($event) {
                                _vm.stafpage = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c("div", [
                  _c("div", { staticClass: "result_title" }, [
                    _vm._v("预估分配结果"),
                  ]),
                  _vm.showDataList
                    ? _c(
                        "div",
                        { staticClass: "result" },
                        _vm._l(_vm.selectedStaff, function (item, index) {
                          return _c(
                            "span",
                            { key: index, staticClass: "result_item" },
                            [
                              _c("span", [_vm._v(_vm._s(index + 1) + ".")]),
                              _c("span", [_vm._v(_vm._s(item.reallyName))]),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "15px" } },
                                [
                                  _vm._v(
                                    _vm._s(item.showAssignNum) +
                                      _vm._s(_vm.unit)
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  !_vm.showDataList
                    ? _c(
                        "div",
                        { staticClass: "result" },
                        _vm._l(_vm.selectedStaff, function (item, index) {
                          return _c(
                            "span",
                            { key: index, staticClass: "result_item" },
                            [
                              _c("span", [_vm._v(_vm._s(index + 1) + ".")]),
                              _c("span", [_vm._v(_vm._s(item.reallyName))]),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "15px" } },
                                [
                                  _vm._v(
                                    _vm._s(item.allocationNum) +
                                      _vm._s(_vm.unit)
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: { click: _vm.handleAllocationDialogClose },
                  },
                  [_vm._v("取 消 ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.allocationSubmit("allocationForm")
                      },
                    },
                  },
                  [_vm._v("分 配 ")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.resultDialog,
            "append-to-body": true,
            title: "分配结果",
            width: "630px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.resultDialog = $event
            },
            close: _vm.handleResultDialog,
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.showData },
            },
            [
              _c("el-table-column", {
                attrs: { property: "sysUserName", label: "姓名", width: "200" },
              }),
              _c("el-table-column", {
                attrs: { property: "address", label: "成功/失败" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticClass: "resultDialogStyle" }, [
                          _c("span", [_vm._v(_vm._s(props.row.successNum))]),
                          _c("span", [_vm._v("/")]),
                          _c(
                            "span",
                            {
                              style:
                                props.row.failedNum >= 1 ? "color:red" : "",
                            },
                            [_vm._v(_vm._s(props.row.failedNum))]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.resultDialogPageNo,
                  "page-size": _vm.resultDialogPageSize,
                  layout: "total, prev, pager, next, jumper",
                  total: _vm.resultDialogTotal,
                },
                on: {
                  "size-change": _vm.handleSizeAllocation,
                  "current-change": _vm.handleCurrentAllocation,
                  "update:currentPage": function ($event) {
                    _vm.resultDialogPageNo = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.resultDialogPageNo = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.leadingInLive,
            "append-to-body": true,
            title: "导入客户",
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.leadingInLive = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "popIn" },
            [
              _c(
                "el-upload",
                {
                  ref: "tops",
                  staticClass: "upload-demo",
                  attrs: {
                    accept: ".doc,.docx,.xls,.xlsx,.csv",
                    drag: "",
                    action: "#",
                    multiple: false,
                    "http-request": _vm.orderImportLive,
                    limit: 1,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-download",
                        size: "mini",
                        type: "text",
                      },
                      on: {
                        click: function ($event) {
                          _vm.DownloadTemplate()
                          _vm.leadingInLive = false
                        },
                      },
                    },
                    [_vm._v("导入模板下载 ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.$refs["tops"].clearFiles()
                        },
                      },
                    },
                    [_vm._v("取 消 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.submission
                          _vm.templateMode()
                          _vm.guideId = ""
                        },
                      },
                    },
                    [_vm._v("确定 ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            id: "show-el-dialog",
            visible: _vm.dialog.visible,
            "append-to-body": true,
            title: _vm.dialog.title,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          [
            _c("el-loading", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fullscreenLoading,
                  expression: " fullscreenLoading ",
                },
              ],
              staticStyle: { position: "absolute", top: "50%", left: "50%" },
              attrs: { lock: true, text: "加载中，请稍候..." },
            }),
            _c(
              "div",
              { staticStyle: { width: "250px" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      rules: _vm.rulesClientCategory,
                      model: _vm.ruleForm,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "类目", prop: "clientCategory" } },
                      [
                        _c("el-cascader", {
                          attrs: {
                            size: "mini",
                            clearable: "",
                            options: _vm.categoryOptions,
                            props: {
                              label: "categoryName",
                              value: "id",
                              checkStrictly: true,
                            },
                            filterable: "",
                          },
                          on: { change: _vm.handleClientCategory },
                          model: {
                            value: _vm.ruleForm.clientCategory,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "clientCategory", $$v)
                            },
                            expression: " ruleForm.clientCategory ",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { display: "inline-block", margin: "0px 20px" } },
              [
                _vm._v(" 员工姓名 "),
                _c("el-input", {
                  staticStyle: { width: "150px" },
                  attrs: { placeholder: "请输入员工姓名", size: "small" },
                  model: {
                    value: _vm.formTc.username,
                    callback: function ($$v) {
                      _vm.$set(_vm.formTc, "username", $$v)
                    },
                    expression: " formTc.username ",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.treeAxios(1)
                  },
                },
              },
              [_vm._v(" 搜索 ")]
            ),
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: "warning" },
                on: {
                  click: function ($event) {
                    return _vm.treeAxios(2)
                  },
                },
              },
              [_vm._v(" 重置 ")]
            ),
            _c(
              "div",
              { staticClass: "tree" },
              [
                _c("el-input", {
                  staticStyle: { margin: "0 0px 20px" },
                  attrs: { placeholder: "输入关键字进行搜索" },
                  model: {
                    value: _vm.filterText,
                    callback: function ($$v) {
                      _vm.filterText = $$v
                    },
                    expression: " filterText ",
                  },
                }),
                _c("el-tree", {
                  ref: "tree",
                  staticClass: "el-menu-vertical-demo",
                  attrs: {
                    data: _vm.tree,
                    props: _vm.defaultProps,
                    "highlight-current": true,
                    "default-expand-all": true,
                    "filter-node-method": _vm.filterNode,
                  },
                  on: { "node-click": _vm.handleNodeClick },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "table1" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tablePerson.list,
                      "row-key": _vm.getRowKey,
                    },
                    on: { "selection-change": _vm.handleSelectionChange1 },
                  },
                  [
                    _vm.isAlot == 2
                      ? _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            "reserve-selection": true,
                            width: "50",
                            align: "center",
                          },
                          model: {
                            value: _vm.multipleSelection1,
                            callback: function ($$v) {
                              _vm.multipleSelection1 = $$v
                            },
                            expression: " multipleSelection1 ",
                          },
                        })
                      : _vm._e(),
                    _vm.isAlot == 1
                      ? _c("el-table-column", {
                          attrs: { width: "50" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: { color: "#fff" },
                                        attrs: { label: scope.$index },
                                        nativeOn: {
                                          change: function ($event) {
                                            return _vm.getCurrentRow(scope.row)
                                          },
                                        },
                                        model: {
                                          value: _vm.multipleSelection,
                                          callback: function ($$v) {
                                            _vm.multipleSelection = $$v
                                          },
                                          expression: " multipleSelection ",
                                        },
                                      },
                                      [_c("span", [_vm._v(" ")])]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1005709933
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { label: "姓名" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("p", [_vm._v(_vm._s(props.row.reallyName))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "联系电话", prop: "phoneNumber" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "所在部门" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.row.orgName))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "职位", prop: "positionName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "员工状态", prop: "statusName" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.tablePerson.totalNum > 0
              ? _c("div", { staticClass: "page2" }, [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.stafpage,
                          "page-size": _vm.stafPageSize,
                          layout: "total,sizes,prev, pager, next",
                          "prev-text": "上一页",
                          "next-text": "下一页",
                          total: _vm.tablePerson.totalNum,
                        },
                        on: {
                          "size-change": _vm.handleSizeEmplay,
                          "current-change": _vm.handleCurrentEmplay,
                          "update:currentPage": function ($event) {
                            _vm.stafpage = $event
                          },
                          "update:current-page": function ($event) {
                            _vm.stafpage = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: {
                      click: function ($event) {
                        _vm.dialog.visible = false
                      },
                    },
                  },
                  [_vm._v("取 消 ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submission("ruleForm")
                      },
                    },
                  },
                  [_vm._v("确 定 ")]
                ),
              ],
              1
            ),
          ],
          _vm.dialog.type == "add"
            ? [
                _c("add-customers", {
                  ref: "addCustomers",
                  on: { closeDialog: _vm.closeDialog },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "导入客户",
            "append-to-body": "",
            visible: _vm.importDialogVisible,
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "statistics" }, [
            _c(
              "div",
              {
                staticClass: "statistics_item",
                staticStyle: { color: "#e6a23c" },
              },
              [_vm._v(" 导入失败 : " + _vm._s(_vm.statistics.exportFail) + " ")]
            ),
            _c(
              "div",
              {
                staticClass: "statistics_item",
                staticStyle: { color: "#67c23a" },
              },
              [
                _vm._v(
                  " 导入成功 : " + _vm._s(_vm.statistics.exportSuccess) + " "
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "statistics_item",
                staticStyle: { color: "#909399" },
              },
              [
                _vm._v(
                  " 未分配 : " + _vm._s(_vm.statistics.assignoreFail) + " "
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "statistics_item",
                staticStyle: { color: "#67c23a" },
              },
              [
                _vm._v(
                  " 分配成功 : " + _vm._s(_vm.statistics.assignoreSuccess) + " "
                ),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                "header-cell-style": { background: "#f8f8f8" },
                data: _vm.importDataList.list,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "批次", width: "60" },
              }),
              _c("el-table-column", {
                attrs: { prop: "resourceId", label: "资源ID", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "订单编号", width: "150" },
              }),
              _c("el-table-column", {
                attrs: { "show-overflow-tooltip": "", label: "客户信息" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", [_vm._v(_vm._s(scope.row.customerName))]),
                        _c("p", [_vm._v(_vm._s(scope.row.customerPhone))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { "show-overflow-tooltip": "", label: "类目" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("p", [_vm._v(_vm._s(scope.row.categoryName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { "show-overflow-tooltip": "", label: "微信号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("p", [_vm._v(_vm._s(scope.row.wechatNo))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "prodName",
                  label: "选购商品",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "channelName ", label: "渠道", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.channelName) + " "),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "platformName", label: "来源", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "payType", label: "类型", width: "85" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "assignorTeamName",
                  label: "公司部门",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "assignorName", label: "跟进客服", width: "90" },
              }),
              _c(
                "el-table-column",
                { attrs: { prop: "address", label: "分配人", width: "100" } },
                [[_c("span", [_vm._v(_vm._s(_vm.useName.reallyName) + " ")])]],
                2
              ),
              _c("el-table-column", {
                attrs: { prop: "address", label: "状态", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            style:
                              scope.row.errorType == null
                                ? "color:#909399"
                                : "" || scope.row.errorType == 0
                                ? "color:#67C23A"
                                : "" || scope.row.errorType > 0
                                ? "color:#F56C6C"
                                : "",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.errorType == null
                                  ? "导入失败"
                                  : "" || scope.row.errorType == 0
                                  ? "分配成功"
                                  : "" || scope.row.errorType > 0
                                  ? "分配失败"
                                  : "" || scope.row.errorType == -1
                                  ? "未分配"
                                  : ""
                              ) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "errorDescription ",
                  label: "失败原因1",
                  width: "240",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.errorDescription) + " "),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "创建时间" },
              }),
              _c("el-table-column", {
                attrs: { prop: "assignTime", label: "分配时间" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "right",
                background: "#f8f8f8",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.importPage,
                  "page-size": _vm.importPageSize,
                  layout: "total,sizes,prev, pager, next",
                  "prev-text": "上一页",
                  "next-text": "下一页",
                  total: _vm.importDataList.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeImport,
                  "current-change": _vm.handleCurrentImport,
                  "update:currentPage": function ($event) {
                    _vm.importPage = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.importPage = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.importDialogVisible = false
                      _vm.fetchData()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.importDialogVisible = false
                      _vm.fetchData()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }